module.exports = __webpack_public_path__ + "img/californiacrane.86424042.png";